import { makeStyles } from "@material-ui/core";
import classNames from "classnames";
// import {
//   GOVGR_FIELD,
//   GOVGR_FIELD__ERROR,
//   GOVGR_LABEL,
// } from "../../conf/styles/GovGrFileInput";
import {
  GOVGR_FIELD,
  GOVGR_FIELD__ERROR,
  GOVGR_LABEL,
} from "../../../conf/styles/GovGrFileInput";

import DeleteButton from "../../../components/GovGrFileInput/DeleteButton";

import ErrorText from "../../../components/GovGrFileInput/Error";
import Input from "../../../components/GovGrFileInput/Input";
import Label from "../../../components/GovGrFileInput/Label";
import ViewButton from "../../../components/GovGrFileInput/ViewButton";
import React, { useState } from 'react';
import { fileUpload } from "../../../services/documentsService";


// C: \Users\mpan\Documents\production_new\yen - thyrida - fe\yen - thyrida - fe\src\components\GovGrFileInput

const LABEL = "Upload file";
const DISABLED_INITIAL_VALUE = false;

const useStyles = makeStyles({
  controlsContainer: {
    maxWidth: "30rem",
    justifyContent: "space-between",
    display: "flex",
    flexWrap: "wrap",
  },
});

const FileUploadAdmin = ({
  label = LABEL,
  hint,
  errorLabel,
  accept,
  document,
  disabled = DISABLED_INITIAL_VALUE,
  InputProps: inputProps,
  InputLabelProps: inputLabelProps,
  disableDeleteButton,
  disableViewButton,
  onChange,
  handleViewFile,
  handleDeleteFile,
  uploadedFilename,
  initiallyUploadedDocuments,
}) => {
  const classes = useStyles();
  const [file, setFile] = useState(null);
  const [description, setDescription] = useState('');

  const onFileChange = (e) => {
    setFile(e.target.files[0]);

    onChange(e);
  };

  const onDescriptionChange = (e) => {
    setDescription(e.target.value);
  };



  let ComponentWrapperClass = classNames(GOVGR_FIELD, {
    [GOVGR_FIELD__ERROR]: errorLabel,
  });

  return (
    <div className={ComponentWrapperClass}>
      <label className={GOVGR_LABEL}>
        <Label label={label} hint={hint} {...inputLabelProps} />
        <ErrorText error={errorLabel} />
        <div className={classes.controlsContainer}>
          <Input
            accept={accept}
            name={label}
            disabled={disabled}
            onChange={onFileChange}
            uploadedFilename={uploadedFilename}
            {...inputProps}
          />
          <div style={{ marginTop: "10px" }}>
            <ViewButton
              handleViewFile={handleViewFile}
              disabled={disableViewButton || !document}
            />
            <DeleteButton
              handleDeleteFile={handleDeleteFile}
              disabled={disableDeleteButton || !document}
            />
          </div>
        </div>
      </label>
    </div>
  );
};

export default FileUploadAdmin;
